(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-comparateur"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.nwkReady) return;
    root.dataset.nwkReady = '1';
    var items = [].slice.call(root.querySelectorAll('[data-nwk-item]'));
    var grid = root.querySelector('[data-nwk-grid]');
    var rows = root.querySelector('[data-nwk-rows]');
    var chips = [].slice.call(root.querySelectorAll('[data-nwk-filter]'));
    var sortSel = root.querySelector('[data-nwk-sort]');
    var bar = root.querySelector('[data-nwk-bar]');
    var picked = root.querySelector('[data-nwk-picked]');
    var filter = 'all';
    var compareOnly = false;

    function picks() {
      return [].slice.call(root.querySelectorAll('[data-nwk-pick]:checked')).map(function (i) { return i.value; });
    }
    function apply() {
      var sel = picks();
      var shown = 0;
      items.forEach(function (el) {
        var tags = ' ' + (el.dataset.tags || '') + ' ';
        var ok = filter === 'all' || tags.indexOf(' ' + filter + ' ') > -1;
        if (compareOnly && el.tagName === 'TR') ok = sel.indexOf(el.dataset.id) > -1;
        el.hidden = !ok;
        if (ok && el.tagName === 'LI') shown++;
      });
      var count = root.querySelector('[data-nwk-count]');
      if (count) count.textContent = shown;
      var empty = root.querySelector('[data-nwk-empty]');
      if (empty) empty.hidden = shown > 0;
      if (bar) {
        bar.hidden = sel.length === 0;
        bar.querySelector('[data-nwk-bar-count]').textContent = sel.length;
        bar.querySelector('[data-nwk-compare]').disabled = sel.length < 2;
      }
      if (picked) {
        picked.hidden = !compareOnly;
        picked.querySelector('[data-nwk-picked-text]').textContent = sel.length + ' ' + (root.dataset.selLabel || '');
      }
    }
    function sortBy(mode) {
      [grid, rows].forEach(function (parent) {
        if (!parent) return;
        var list = [].slice.call(parent.children);
        list.sort(function (a, b) {
          var ra = a.dataset.id && a.dataset.id.indexOf('ref-') === 0 ? 1 : 0;
          var rb = b.dataset.id && b.dataset.id.indexOf('ref-') === 0 ? 1 : 0;
          if (ra !== rb) return ra - rb;
          if (mode === 'name') return (a.dataset.name || '').localeCompare(b.dataset.name || '');
          var d = (+a.dataset.price || 0) - (+b.dataset.price || 0);
          return mode === 'price-desc' ? -d : d;
        });
        list.forEach(function (el) { parent.appendChild(el); });
      });
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        filter = chip.dataset.nwkFilter;
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () { sortBy(sortSel.value); });
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-nwk-pick]')) return;
      if (picks().length > 4) { e.target.checked = false; return; }
      if (picks().length < 2) compareOnly = false;
      apply();
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-nwk-compare]')) {
        compareOnly = true;
        apply();
        var target = root.querySelector('#comparatif');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (e.target.closest('[data-nwk-reset]')) {
        compareOnly = false;
        apply();
      } else if (e.target.closest('[data-nwk-clear]')) {
        [].slice.call(root.querySelectorAll('[data-nwk-pick]:checked')).forEach(function (i) { i.checked = false; });
        compareOnly = false;
        apply();
      }
    });
    apply();
  }
  function boot() { [].slice.call(document.querySelectorAll('[data-nwk]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
